import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const createStyle = (color?: string) => {
    return makeStyles({
        terminal: {
            position: 'absolute',
            top: '20%',
            left: '20%',
            width: '60%',
            height: '60%',
            borderRadius: 4,
            backgroundColor: color
        }
    })
}

export interface TerminalProps {
    color: string
}

export const Terminal = React.memo((props: TerminalProps): JSX.Element => {
    const { color } = props
    const useStyles = React.useCallback(createStyle(color), [color])
    const classes = useStyles()

    return <div className={classes.terminal} />
})
